<template>
  <div class="team-info">
    <ucar-title>{{title}}</ucar-title>
    <ucar-section class="info-city">
      <div class="row">
        <label>服务城市</label>
        <ucar-city-select
          :options="[]"
          :disabled="true"
          @click.native="goIndex('chooseCity')"
          placeholder="请选择"
          v-model="vuexCurrentCity"
        ></ucar-city-select>
      </div>
    </ucar-section>
    <ucar-section>
      <div class="row">
        <label>企业名称</label>
        <dynamic-textarea v-model="info.companyName" :maxlength="20" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>司机规模</label>
        <ucar-select
          :options="baseData.driverScopeOptions"
          placeholder="请选择"
          v-model="info.driverScale"
        ></ucar-select>
      </div>
      <div class="row">
        <label>车辆规模</label>
        <ucar-select
          :options="baseData.carScopeOptions"
          placeholder="请选择"
          v-model="info.vehicleScale"
        ></ucar-select>
      </div>
    </ucar-section>
    <ucar-section>
      <div class="row">
        <label>联系人姓名</label>
        <dynamic-textarea v-model="info.contactName" :maxlength="20" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>联系人手机号</label>
        <div class="value">{{info.contactPhone}}</div>
      </div>
      <div class="row">
        <label>联系人邮箱</label>
        <dynamic-textarea v-model="info.contactMail" :maxlength="40" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>详细地址</label>
        <dynamic-textarea v-model="info.companyAddress" :maxlength="50" placeholder="请输入"></dynamic-textarea>
      </div>
    </ucar-section>
    <div class="footer">
      <button type="button" class="btn-submit" :class="{'btn-submit-enable': enableSubmit}" @click="submit">
        提交
      </button>
    </div>
  </div>
</template>

<script>
import DynamicTextarea from '../../components/dynamic-textarea'
import valid from '../../utils/valid-check'
import { submitTeamInfo } from '../../api'

export default {
  data () {
    return {
      title: '神州专车车队招募',
      info: {
        companyName: '',
        driverScale: '',
        vehicleScale: '',
        contactName: '',
        contactPhone: '',
        contactMail: '',
        companyAddress: ''
      },
      baseData: {
        driverScopeOptions: [
          {
            name: '1-10人',
            value: 1
          },
          {
            name: '11-30人',
            value: 2
          },
          {
            name: '31-50人',
            value: 3
          },
          {
            name: '51-100人',
            value: 4
          },
          {
            name: '101-200人',
            value: 5
          },
          {
            name: '200-500人',
            value: 6
          },
          {
            name: '500人以上',
            value: 7
          }
        ],
        carScopeOptions: [
          {
            name: '1-10辆',
            value: 1
          },
          {
            name: '11-30辆',
            value: 2
          },
          {
            name: '31-50辆',
            value: 3
          },
          {
            name: '51-100辆',
            value: 4
          },
          {
            name: '101-200辆',
            value: 5
          },
          {
            name: '200-500辆',
            value: 6
          },
          {
            name: '500辆以上',
            value: 7
          }
        ]
      }
    }
  },
  components: {
    DynamicTextarea
  },
  computed: {
    enableSubmit () {
      const errorInfo =
        valid.notEmpty(this.info.companyName, '企业名称') ||
        valid.notEmpty(this.info.driverScale, '司机规模') ||
        valid.notEmpty(this.info.vehicleScale, '车辆规模') ||
        valid.notEmpty(this.info.contactName, '联系人姓名') ||
        valid.notEmpty(this.info.contactPhone, '联系人手机号') ||
        valid.notEmpty(this.info.contactMail, '联系人邮箱') ||
        valid.notEmpty(this.info.companyAddress, '详细地址')
      return errorInfo === ''
    }
  },
  methods: {
    submit () {
      this.info.companyName = this.info.companyName.trim()
      this.info.contactPhone = this.info.contactPhone.trim()
      this.info.contactName = this.info.contactName.trim()
      this.info.contactMail = this.info.contactMail.trim()
      this.info.companyAddress = this.info.companyAddress.trim()
      const errorInfo =
        valid.companyName(this.info.companyName, '企业名称格式有误') ||
        valid.cnName(this.info.contactName, '请输入正确的联系人姓名') ||
        valid.email(this.info.contactMail, '请输入正确的联系人邮箱')
      if (errorInfo) {
        this.$alert(errorInfo)
        return
      }
      submitTeamInfo({
        ...this.info,
        cityId: this.vuexCurrentCity.id
      })
        .then(res => {
          if (res.success) {
            this.changeStatusToTeamReviewInfo()
            this.$router.push(`/team-result?id=${res.recruitId}`)
          } else {
            this.$alert(res.message)
          }
        })
    },
    cacheData () {
      const data = this.info
      this.setVuexTeamInfo(data)
      this.cacheInfoForLongTime('team', data)
    },
    goIndex () {
      this.cacheData()
      this.$alert({
        type: 'confirm',
        dsc: '不同服务城市的业务不同，更改服务城市后需重新选择加入方式',
        okText: '确认更改',
        showCancel: true,
        center: true,
        callback: () => {
          this.$router.push(this.vuexCompanyId ? `${this.vuexIndexUrl}&showCityChoose=true` : '/?showCityChoose=true')
        }
      })
    },
    init () {
      this.info.contactPhone = this.vuexPersonMobile
      const cachedInfo = this.findCachedInfo()
      if (cachedInfo && cachedInfo.teamInfo) {
        this.setVuexTeamInfo(cachedInfo.teamInfo)
        this.info = cachedInfo.teamInfo
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
